export default {
    culture: String, 
    dates: Array, 
    depth: String, 
    disableDates: [Array, Function], 
    footer: [String, Function], 
    format: String, 
    max: Date, 
    messages: Object, 
    min: Date, 
    month: Object, 
    views: Number, 
    range: Object, 
    selectable: String, 
    selectDates: Array, 
    showViewHeader: Boolean, 
    weekNumber: Boolean, 
    start: String, 
    value: Date, 

    // Events
    change: Function, 
    navigate: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoMultiViewCalendar/MultiViewCalendarProps.js